import React from 'react';
import FunctionCard from './FunctionCard';
import { Center, Title } from '@mantine/core';

interface Function {
    functionId: number;
    functionName: string;
    description?: string;
    eventID?: number;
    functionCategoryId?: number;
}

interface FunctionsListProps {
    functions: Function[];
    language: 'da' | 'en';
    eventID: number;
}

const Functionlist: React.FC<FunctionsListProps> = ({ functions, language, eventID }) => {


    return (
        <div>
            <Center my="md">
                <Title order={2}>
                    {language === 'da' ? 'Funktioner' : 'Functions'}
                </Title>
            </Center>
            {functions.length === 0 ? (
                <p>{language === 'da' ? 'Ingen funktioner tilgængelige.' : 'No functions available.'}</p>
            ) : (
                    <div className="group-list">
                        {functions
                            .filter((f) => f.functionCategoryId === 10)
                            .map((funtion) => (
                                <FunctionCard
                                    key={funtion.functionId}
                                    title={language === 'da' ? funtion.functionName : funtion.functionName}
                                    description={language === 'da' ? funtion.description || '' : funtion.description || ''}
                                    functionId={funtion.functionId}
                                    eventId={eventID}
                                />
                            ))}
                    </div>
            )}
        </div>
    );
};

export default Functionlist;
